import { ButtonConfig } from '@zipari/shared-ds-util-button';
import { NavigationLinkTargets } from './navigation.model';

export interface LinkConfig {
  label: string;
  /**
   * for external links
   */
  bold?: boolean;
  externalLink?: string;
  useExternalSiteModal?: boolean;
  showExternalSiteIcon?: boolean;
  /**
   * @description used by the mobile apps to improve performance by skipping cookies, session, etc.
   */
  useUnauthenticatedWebView?: boolean;
  /**
   * for app routes
   */
  route?: string;
  target?: NavigationLinkTargets;
  /**
   * Additional text to display with the link
   */
  description?: string;
  button?: ButtonConfig;
  /** attach arbitrary data here */
  metaData?: any;
  /** if you find yourself needing to remove the link styles, consider just using a different component */
  removeLinkStyles?: boolean;
  /** go back to previous page if true */
  goBack?: boolean;

  transaction_code?: string;
  transaction_label?: string;
}
